import { FORM_NAMES } from 'consts/formNames';
import updateDataValidation from '../helpers/updateDataValidation';

export const formConfig = {
  form: FORM_NAMES.UPDATE_DATA,
  shouldValidate: () => true,
  validate: updateDataValidation,
  onSubmitFail: (error) => {
    if (DEBUG) {
      console.warn('form submit fail', error);
    }
  },
};
